import styled, { css } from 'styled-components';
import { colors } from 'components/styles/_variables';
import { respondTo } from '../../../styles/_respondTo';

export const Wrapper = styled.div`
  ${({ variant }) => variant === 'exception' && css`
    padding: 40px 0;
    border-bottom: 1px solid ${colors.elements.border};
  `}
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: ${({ pr = 0 }) => pr}px;
  margin-top: ${({ mt = 10 }) => mt}px;
`;

export const SelectDivider = styled.span`
  margin: 0 7px;
  font-size: 16px;
  font-weight: 600;
  line-height: 2.13;
  letter-spacing: -0.27px;
  color: #636262;
`;

export const ExceptionCHipWrapper = styled.div`
  position: relative;
  padding: 0 40px;
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 33px;
  cursor: pointer;
  ${({ variant }) => variant === 'exception' && css`
    position: absolute;
    right: 30px;
    top: 5px;
  `}
`;
